import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, TrendingDown, Users, DollarSign } from 'lucide-react';
export function Problems() {
  const problems = [{
    icon: AlertTriangle,
    title: 'Regulatory Maze',
    description: 'Navigating complex iGaming compliance across jurisdictions without triggering penalties or deindexing.',
    color: '#ef4444'
  }, {
    icon: TrendingDown,
    title: 'Invisible Rankings',
    description: 'Your sportsbook affiliate pages buried beneath competitors on page 4, bleeding potential revenue.',
    color: '#f59e0b'
  }, {
    icon: Users,
    title: 'Leaking Conversions',
    description: 'Traffic that never converts to depositing players. High bounce rates, low player lifetime value.',
    color: '#ef4444'
  }, {
    icon: DollarSign,
    title: 'Affiliate Chaos',
    description: 'Untracked partnerships, missing attribution, and commission revenue disappearing into the void.',
    color: '#f59e0b'
  }];
  return <section className="py-20 bg-[#0d2818]" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-122">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-123">
            The Odds Are{' '}
            <span className="text-[#ef4444]" data-id="element-124">Stacked Against You</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-125">
            Sports betting affiliates face unique challenges that traditional
            SEO agencies can't solve
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-126">
          {problems.map((problem, index) => {
          const Icon = problem.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-[#0a1a0f] border-l-4 rounded-lg p-6 hover:bg-[#0a1a0f]/80 transition-colors" style={{
            borderLeftColor: problem.color
          }} data-id="element-127">
                <div className="flex items-start space-x-4" data-id="element-128">
                  <div className="flex-shrink-0" data-id="element-129">
                    <Icon size={32} style={{
                  color: problem.color
                }} data-id="element-130" />
                  </div>
                  <div data-id="element-131">
                    <h3 className="text-xl font-bold mb-2" data-id="element-132">{problem.title}</h3>
                    <p className="text-gray-400" data-id="element-133">{problem.description}</p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}